import React from "react";
import Button from "./Button";
import themeThumbnail from "../../assets/images/theme-thumbnail.png";
import Ribbon from "./Ribbon";

const ThemesCard = ({ ribbonType, isPremium, onClick }) => {
  const hoverColors = {
    basic: "hover:shadow-[0px_10px_20px_rgba(11,115,226,0.4)]",
    premium: "hover:shadow-[0px_10px_20px_rgba(236,124,101,0.4)]",
    vip: "hover:shadow-[0px_10px_20px_rgba(246,184,71,0.6)]",
  };

  return (
    <div
      className={`bg-white rounded-lg shadow-lg w-full max-w-[350px] mx-auto flex flex-col relative transition-all duration-500 ease-in-out transform hover:translate-y-[-5px] ${
        hoverColors[ribbonType] || "hover:shadow-lg"
      }`}
    >
      {/* Wrapper Gambar + Ribbon */}
      <div className="relative overflow-hidden rounded-t-lg">
        <img
          src={themeThumbnail}
          alt="Theme Thumbnail"
          className="w-full h-[140px] object-cover transition-transform duration-500 ease-in-out hover:scale-110"
        />
        {ribbonType && (
          <div className="absolute top-2 right-0">
            <Ribbon type={ribbonType} />
          </div>
        )}
      </div>

      <div className="pr-4 pl-6 py-4 pb-4">
        <h3 className="text-[#E98362] font-montserrat font-bold text-[14px] text-left">
          Title Themes
        </h3>
        <p className="text-gray-600 font-montserrat text-[12px] text-justify mt-1">
          Lorem ipsum dolor sit amet, consectetur adipis elit. Sit enim nec,
          proin faucibus nibh et sagittis a. Lacinia purus ac amet.
        </p>

        <div className="mt-4">
          {/* Tambahkan event onClick */}
          <Button
            text={isPremium ? "Beli Tema" : "Pakai Tema"}
            className="w-full"
            onClick={onClick} // Tambahkan handler klik
          />
        </div>
      </div>
    </div>
  );
};

export default ThemesCard;
